module.exports = __webpack_public_path__ + "media/images/favicons/safari-pinned-tab-49cc4e88f7f11b76276829bcfd869ef8.svg";